import { createAction } from '@reduxjs/toolkit';
import { AvatarCacheItem } from './reducer';

export enum ActionType {
  SET = 'avatars/set',
}

const actions = {
  set: createAction<AvatarCacheItem>(ActionType.SET),
};

export default actions;
